import React from "react";
import CreateContentField from "./CreateContentField";
import { Box, Card, TextField } from "@material-ui/core";
import Collapse from "@material-ui/core/Collapse";
import { BonusDrawModel } from "../../../types/generalContent";
import { CollapseState } from "../GeneralContent";
import AddIcon from "@material-ui/icons/AddCircleOutline";
import RemoveIcon from "@material-ui/icons/RemoveCircleOutline";

interface BonusDrawCardsProps {
  state: BonusDrawModel;
  collapseState: CollapseState;
  toggleCard: (name: string) => void;
  errors: Record<string, string>;
  handleChange: (e: any) => void;
  handleAddInfoDescription: (name: string, category: string) => void;
  handleRemoveContentIconItem: (id: string, name: string) => void;
  handleRemoveContentDescriptionItem: (
    i: number,
    name: string,
    category: string
  ) => void;
  handleRemoveGalleryItem: (i: number, name: string) => void;
}

const BonusDrawCards = ({
  state,
  collapseState,
  toggleCard,
  errors,
  handleChange,
  handleAddInfoDescription,
  handleRemoveContentIconItem,
  handleRemoveContentDescriptionItem,
  handleRemoveGalleryItem,
}: BonusDrawCardsProps) => {
  return (
    <div className="content__section">
      <h2 className="content__subtitle">Bonus Draw Page:</h2>
      <Box className="content__box">
        <Card className="content__card">
          <span
            className={`content__card-label ${
              collapseState.bdMainImage ? "open" : "close"
            }`}
            onClick={() => toggleCard("bdMainImage")}
          >
            Main Image
          </span>
          <Collapse in={collapseState.bdMainImage}>
            <div className="content__fields-row">
              <CreateContentField
                fieldTitle="Title:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="bonusDraw.title"
                      error={!!errors[`bonusDraw.title`]}
                      helperText={errors[`bonusDraw.title`]}
                      onChange={handleChange}
                      value={state.title}
                    />
                  </Box>
                }
              />
              <CreateContentField
                fieldTitle="Badge icon URL:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="bonusDraw.badgeUrl"
                      onChange={handleChange}
                      value={state.badgeUrl}
                    />
                  </Box>
                }
              />
              <CreateContentField
                fieldTitle="Badge Price:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="bonusDraw.badgePrice"
                      onChange={handleChange}
                      value={state.badgePrice}
                    />
                  </Box>
                }
              />
            </div>
            <div className="content__fields-row">
              <CreateContentField
                fieldTitle="Image800Url:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="bonusDraw.mainImage.image800Url"
                      error={!!errors[`bonusDraw.mainImage.image800Url`]}
                      helperText={errors[`bonusDraw.mainImage.image800Url`]}
                      onChange={handleChange}
                      value={state.mainImage.image800Url}
                    />
                  </Box>
                }
              />
              <CreateContentField
                fieldTitle="Image1600Url:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="bonusDraw.mainImage.image1600Url"
                      error={!!errors[`bonusDraw.mainImage.image1600Url`]}
                      helperText={errors[`bonusDraw.mainImage.image1600Url`]}
                      onChange={handleChange}
                      value={state.mainImage.image1600Url}
                    />
                  </Box>
                }
              />
            </div>

            <div className="content__fields-row">
              <CreateContentField
                fieldTitle="Image2048Url:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="bonusDraw.mainImage.image2048Url"
                      error={!!errors[`bonusDraw.mainImage.image2048Url`]}
                      helperText={errors[`bonusDraw.mainImage.image2048Url`]}
                      onChange={handleChange}
                      value={state.mainImage.image2048Url}
                    />
                  </Box>
                }
              />
              <CreateContentField
                fieldTitle="Image3840Url:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="bonusDraw.mainImage.image3840Url"
                      error={!!errors[`bonusDraw.mainImage.image3840Url`]}
                      helperText={errors[`bonusDraw.mainImage.image3840Url`]}
                      onChange={handleChange}
                      value={state.mainImage.image3840Url}
                    />
                  </Box>
                }
              />
            </div>
          </Collapse>
        </Card>

        <Card className="content__card">
          <span
            className={`content__card-label ${
              collapseState.bdvideo ? "open" : "close"
            }`}
            onClick={() => toggleCard("bdvideo")}
          >
            Hero Video
          </span>
          <Collapse in={collapseState.bdvideo}>
            <div className="content__fields-row">
              <CreateContentField
                fieldTitle="video desktop Url:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="bonusDraw.video.videoDesktopUrl"
                      onChange={handleChange}
                      value={state.video.videoDesktopUrl}
                    />
                  </Box>
                }
              />
              <CreateContentField
                fieldTitle="video preview Url:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="bonusDraw.video.videoPreviewUrl"
                      onChange={handleChange}
                      value={state.video.videoPreviewUrl}
                    />
                  </Box>
                }
              />
            </div>
            <div className="content__fields-row">
              <CreateContentField
                fieldTitle="video mobile Url:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="bonusDraw.video.videoMobileUrl"
                      onChange={handleChange}
                      value={state.video.videoMobileUrl}
                    />
                  </Box>
                }
              />
              <CreateContentField
                fieldTitle="video mobile preview Url:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="bonusDraw.video.videoPreviewMobileUrl"
                      onChange={handleChange}
                      value={state.video.videoPreviewMobileUrl}
                    />
                  </Box>
                }
              />
            </div>
          </Collapse>
        </Card>

        <Card className="content__card">
          <span
            className={`content__card-label ${
              collapseState.bdContent ? "open" : "close"
            }`}
            onClick={() => toggleCard("bdContent")}
          >
            Key Highlights
          </span>
          <Collapse in={collapseState.bdContent}>
            <div className="content__fields-row">
              <CreateContentField
                fieldTitle="Title:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="bonusDraw.content.title"
                      onChange={handleChange}
                      value={state.content.title || ""}
                    />
                  </Box>
                }
              />
            </div>
            <span className="content__item-label">Image:</span>
            <div className="content__fields-row">
              <CreateContentField
                fieldTitle="image URL:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="bonusDraw.content.imageUrl"
                      error={!!errors[`bonusDraw.content.imageUrl`]}
                      helperText={errors[`bonusDraw.content.imageUrl`]}
                      onChange={handleChange}
                      value={state.content.imageUrl}
                    />
                  </Box>
                }
              />
              <CreateContentField
                fieldTitle="image x2 URL:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="bonusDraw.content.imageX2Url"
                      error={!!errors[`bonusDraw.content.imageX2Url`]}
                      helperText={errors[`bonusDraw.content.imageX2Url`]}
                      onChange={handleChange}
                      value={state.content.imageX2Url}
                    />
                  </Box>
                }
              />
            </div>
            <div className="content__fields-row">
              <CreateContentField
                fieldTitle="image Mobile URL:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="bonusDraw.content.imageMobileUrl"
                      error={!!errors[`bonusDraw.content.imageMobileUrl`]}
                      helperText={errors[`bonusDraw.content.imageMobileUrl`]}
                      onChange={handleChange}
                      value={state.content.imageMobileUrl}
                    />
                  </Box>
                }
              />
              <CreateContentField
                fieldTitle="image Mobile x2 URL:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="bonusDraw.content.imageMobileX2Url"
                      error={!!errors[`bonusDraw.content.imageMobileX2Url`]}
                      helperText={errors[`bonusDraw.content.imageMobileX2Url`]}
                      onChange={handleChange}
                      value={state.content.imageMobileX2Url}
                    />
                  </Box>
                }
              />
            </div>
            <div className="content__fields-row centered">
              <span className="content__item-label">Icons:</span>
              <button
                className="content__add-btn centered"
                type="button"
                onClick={() =>
                  handleAddInfoDescription(
                    `bonusDraw.content.icons[${state.content.icons.length}]`,
                    "icon"
                  )
                }
              >
                <AddIcon />
              </button>
            </div>
            {state.content.icons.map((icon, i) => {
              return (
                <div className="content__fields-list-item" key={icon._id}>
                  <div className="content__fields-row">
                    <CreateContentField
                      fieldTitle="Icon Title:"
                      field={
                        <Box>
                          <TextField
                            label=""
                            size="small"
                            variant="outlined"
                            type="text"
                            name={`bonusDraw.content.icons[${i}].iconTitle`}
                            error={
                              !!errors[
                                `bonusDraw.content.icons[${i}].iconTitle`
                              ]
                            }
                            helperText={
                              errors[`bonusDraw.content.icons[${i}].iconTitle`]
                            }
                            onChange={handleChange}
                            value={state.content.icons[i].iconTitle}
                          />
                        </Box>
                      }
                    />
                    <CreateContentField
                      fieldTitle="Icon URL:"
                      field={
                        <Box>
                          <TextField
                            label=""
                            size="small"
                            variant="outlined"
                            type="text"
                            name={`bonusDraw.content.icons[${i}].iconUrl`}
                            error={
                              !!errors[`bonusDraw.content.icons[${i}].iconUrl`]
                            }
                            helperText={
                              errors[`bonusDraw.content.icons[${i}].iconUrl`]
                            }
                            onChange={handleChange}
                            value={state.content.icons[i].iconUrl}
                          />
                        </Box>
                      }
                    />
                    <CreateContentField
                      fieldTitle="Icon Description:"
                      field={
                        <Box>
                          <TextField
                            label=""
                            size="small"
                            variant="outlined"
                            type="text"
                            name={`bonusDraw.content.icons[${i}].iconDescription`}
                            onChange={handleChange}
                            value={state.content.icons[i].iconDescription || ""}
                          />
                        </Box>
                      }
                    />
                    {state.content.icons.length > 1 && (
                      <button
                        className="content__delete-btn"
                        type="button"
                        onClick={() =>
                          handleRemoveContentIconItem(icon._id, "bonusDraw")
                        }
                      >
                        <RemoveIcon />
                      </button>
                    )}
                  </div>
                </div>
              );
            })}

            <div className="content__fields-row centered">
              <span className="content__item-label">Description:</span>
              <button
                className="content__add-btn centered"
                type="button"
                onClick={() =>
                  handleAddInfoDescription(
                    `bonusDraw.content.description[${state.content.description.length}]`,
                    "description"
                  )
                }
              >
                <AddIcon />
              </button>
            </div>
            {state.content.description.map((descr, i) => {
              return (
                <div className="content__fields-list-item" key={i}>
                  <div className="content__fields-row">
                    <CreateContentField
                      fieldTitle=""
                      field={
                        <Box>
                          <TextField
                            label=""
                            size="small"
                            variant="outlined"
                            type="text"
                            name={`bonusDraw.content.description[${i}]`}
                            error={
                              !!errors[`bonusDraw.content.description[${i}]`]
                            }
                            helperText={
                              errors[`bonusDraw.content.description[${i}]`]
                            }
                            onChange={handleChange}
                            value={descr}
                          />
                        </Box>
                      }
                    />
                    {state.content.description.length > 1 && (
                      <button
                        className="content__delete-btn centered"
                        type="button"
                        onClick={() =>
                          handleRemoveContentDescriptionItem(
                            i,
                            "description",
                            "bonusDraw"
                          )
                        }
                      >
                        <RemoveIcon />
                      </button>
                    )}
                  </div>
                </div>
              );
            })}
          </Collapse>
        </Card>

        <Card className="content__card">
          <span
            className={`content__card-label ${
              collapseState.bdGallery ? "open" : "close"
            }`}
            onClick={() => toggleCard("bdGallery")}
          >
            Gallery
          </span>
          <Collapse in={collapseState.bdGallery}>
            <div className="content__fields-row centered">
              <span className="content__item-label">
                gallery slides({state.gallery.length}):
              </span>
              <button
                className="content__add-btn centered"
                type="button"
                onClick={() =>
                  handleAddInfoDescription(
                    `bonusDraw.gallery[${state.gallery.length}]`,
                    "gallery"
                  )
                }
              >
                <AddIcon />
              </button>
            </div>
            {state.gallery.map((slide, i) => {
              return (
                <div className="content__fields-item" key={i}>
                  <div className="content__fields-row">
                    <CreateContentField
                      fieldTitle="Title:"
                      field={
                        <Box>
                          <TextField
                            label=""
                            size="small"
                            variant="outlined"
                            type="text"
                            name={`bonusDraw.gallery[${i}].title`}
                            error={!!errors[`bonusDraw.gallery[${i}].title`]}
                            helperText={errors[`bonusDraw.gallery[${i}].title`]}
                            onChange={handleChange}
                            value={slide.title}
                          />
                        </Box>
                      }
                    />
                    <CreateContentField
                      fieldTitle="Description:"
                      field={
                        <Box>
                          <TextField
                            label=""
                            size="small"
                            variant="outlined"
                            type="text"
                            name={`bonusDraw.gallery[${i}].description`}
                            error={
                              !!errors[`bonusDraw.gallery[${i}].description`]
                            }
                            helperText={
                              errors[`bonusDraw.gallery[${i}].description`]
                            }
                            onChange={handleChange}
                            value={slide.description}
                          />
                        </Box>
                      }
                    />
                    {state.gallery.length > 1 && (
                      <button
                        className="content__delete-btn"
                        type="button"
                        onClick={() => handleRemoveGalleryItem(i, "bonusDraw")}
                      >
                        <RemoveIcon />
                      </button>
                    )}
                  </div>
                  <div className="content__fields-row">
                    <CreateContentField
                      fieldTitle="image 800 URL:"
                      field={
                        <Box>
                          <TextField
                            label=""
                            size="small"
                            variant="outlined"
                            type="text"
                            name={`bonusDraw.gallery[${i}].image800Url`}
                            error={
                              !!errors[`bonusDraw.gallery[${i}].image800Url`]
                            }
                            helperText={
                              errors[`bonusDraw.gallery[${i}].image800Url`]
                            }
                            onChange={handleChange}
                            value={slide.image800Url}
                          />
                        </Box>
                      }
                    />
                    <CreateContentField
                      fieldTitle="image 1600 URL:"
                      field={
                        <Box>
                          <TextField
                            label=""
                            size="small"
                            variant="outlined"
                            type="text"
                            name={`bonusDraw.gallery[${i}].image1600Url`}
                            error={
                              !!errors[`bonusDraw.gallery[${i}].image1600Url`]
                            }
                            helperText={
                              errors[`bonusDraw.gallery[${i}].image1600Url`]
                            }
                            onChange={handleChange}
                            value={slide.image1600Url}
                          />
                        </Box>
                      }
                    />
                  </div>
                  <div className="content__fields-row">
                    <CreateContentField
                      fieldTitle="image 2048 URL:"
                      field={
                        <Box>
                          <TextField
                            label=""
                            size="small"
                            variant="outlined"
                            type="text"
                            name={`bonusDraw.gallery[${i}].image2048Url`}
                            error={
                              !!errors[`bonusDraw.gallery[${i}].image2048Url`]
                            }
                            helperText={
                              errors[`bonusDraw.gallery[${i}].image2048Url`]
                            }
                            onChange={handleChange}
                            value={slide.image2048Url}
                          />
                        </Box>
                      }
                    />
                    <CreateContentField
                      fieldTitle="image 3840 URL:"
                      field={
                        <Box>
                          <TextField
                            label=""
                            size="small"
                            variant="outlined"
                            type="text"
                            name={`bonusDraw.gallery[${i}].image3840Url`}
                            error={
                              !!errors[`bonusDraw.gallery[${i}].image3840Url`]
                            }
                            helperText={
                              errors[`bonusDraw.gallery[${i}].image3840Url`]
                            }
                            onChange={handleChange}
                            value={slide.image3840Url}
                          />
                        </Box>
                      }
                    />
                  </div>
                </div>
              );
            })}
          </Collapse>
        </Card>
      </Box>
    </div>
  );
};

export default BonusDrawCards;
